import {
  GET_TEMPORARY_UNIONS_SUMMARY,
  GET_TEMPORARY_UNIONS_SUMMARY_ERROR,
  GET_TEMPORARY_UNIONS_SUMMARY_SUCCESS,
  GET_TEMPORARY_UNION_FILE,
  GET_TEMPORARY_UNION_FILE_ERROR,
  GET_TEMPORARY_UNION_FILE_SUCCESS
} from './TemporaryUnionsSection.actions'

const temporaryUnionsState = {
  unions: [],
  error: undefined,
  loading: true,
  pdfDownload: {}
}

/**
 * The Temporary Unions' reducer.
 */
const temporaryUnionsReducer = (state = temporaryUnionsState, { payload, type }) => {
  switch (type) {
    case GET_TEMPORARY_UNIONS_SUMMARY: {
      return { ...state, loading: true }
    }
    case GET_TEMPORARY_UNIONS_SUMMARY_SUCCESS: {
      return {
        ...state,
        loading: false,
        unions: payload.unions,
        error: false
      }
    }
    case GET_TEMPORARY_UNIONS_SUMMARY_ERROR: {
      return {
        ...state,
        loading: false,
        error: payload.error
      }
    }
    case GET_TEMPORARY_UNION_FILE: {
      return {
        ...state,
        pdfDownload: {
          ...state.pdfDownload,
          loading: true
        }
      }
    }
    case GET_TEMPORARY_UNION_FILE_SUCCESS: {
      return {
        ...state,
        pdfDownload: {
          loading: false,
          ...payload
        },
        error: false
      }
    }
    case GET_TEMPORARY_UNION_FILE_ERROR: {
      return {
        ...state,
        pdfDownload: {
          loading: false,
          error: payload.error
        }
      }
    }
    default: {
      return state
    }
  }
}

export default temporaryUnionsReducer
